import { thisBaseURL} from "../../utils/helper.js";

function Login() {
	window.location.replace(thisBaseURL + '/saml/login');
 
  return (
    <div />
  );
}
export default Login;
